/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { CpdsBoxLayoutStyleTag } from './styles/cpds-box-layout-style';
import { CpdsBoxLayoutProps } from './typings';
import { themeStyleClass } from '../utils/cpds-utils';

const CpdsBoxLayout: React.FC<CpdsBoxLayoutProps> = (props) => {  
  const { domRef, exClasses, styleOverrides, themeTypography, children, columns, axis } = props;
  const className = themeStyleClass('cpds-box-layout', themeTypography, exClasses);

  /* Important : By default html tag is <div></div> 
  but you can change that into suitable html element base on your requirements*/
  return (
    <CpdsBoxLayoutStyleTag className={className} ref={domRef} styleOverrides={styleOverrides} columnsCount={columns} axis={axis}>
      {children}
    </CpdsBoxLayoutStyleTag>
  );
};

export default CpdsBoxLayout;

